import { render } from "./UiButton.vue?vue&type=template&id=40240c75&scoped=true"
import script from "./UiButton.vue?vue&type=script&lang=js"
export * from "./UiButton.vue?vue&type=script&lang=js"

import "./UiButton.vue?vue&type=style&index=0&id=40240c75&scoped=true&lang=css"

import exportComponent from "/home/drdilyor/workspace/minesweeper/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40240c75"]])

export default __exports__